import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';

export const acknowledgeReleaseNotes = async ({ rootState, state, commit }: SafeAny) => {
  const latestVersion = state.releaseNotes.data?.[0]?.version;

  if (!latestVersion) return;

  const url = `${rootState.env.requestUrl.events}/release-notes`;

  try {
    await axiosInstance.patch(url, { version: latestVersion });
  } catch (error: SafeAny) {
    commit(
      'addNotification',
      {
        i18nTitle: 'errorAcknowledgeReleaseNotes',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
